import { AppSumoContext } from "contexts/AppSumoContext";
import { CompanyContext } from "contexts/CompanyContext";
import { SessionContext } from "contexts/SessionContext";
import { useContext } from "react";

const useImageGenerationQuantity = () => {

    const { isSumoling } = useContext(AppSumoContext);  
    const { mainUser } = useContext(CompanyContext);

    let qty = 5;

    // if (mainUser?.subscription?.items?.[0]?.product?.name == "essential") qty = 1;
    // if (mainUser?.subscription?.items?.[0]?.product?.name == "free") qty = 5;
    // if (mainUser?.subscription?.items?.[0]?.product?.name == "pro") qty = 5;
    // if (mainUser?.subscription?.items?.[0]?.product?.name == "team") qty = 5;
    // if (mainUser?.subscription?.items?.[0]?.product?.name == "agency") qty = 5;

    return qty;
}

export default useImageGenerationQuantity;